import HttpService from '../baseHttp'

// b2b列表
export const HttpB2BList = (data = {}, config) => HttpService.get('/api/v2/B2bOrder/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 编辑、添加
export const HttpSaveOne = (data = {}, config) => HttpService.post('/api/v2/B2bOrder/saveOne', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 查看单条
export const HttpGetOne = (data = {}, config) => HttpService.get('/api/v2/B2bOrder/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 推送云仓，直接发货，订单确认/取消
export const HttpPushYuncang = (data = {}, config) => HttpService.get('/api/v2/B2bOrder/pushWarehouse', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpDirectShipment = (data = {}, config) => HttpService.get('/api/v2/B2bOrder/closeOrder', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpOrderConfirm = (data = {}, config) => HttpService.get('/api/v2/B2bOrder/confirm', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

export const HttpOrderCancel = (data = {}, config) => HttpService.get('/api/v2/B2bOrder/cancelOrder', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })


// 用户地址列表
export const HttpAllCustomerAddressList = (data = {}, config) => HttpService.get('/api/v2/Customer/findByCustomerId', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 获取可用库存
export const HttpGetAvailQuantity = (data = {}, config) => HttpService.post('/api/v2/StockGroupInventory/getAvailQuantity', data, { headers: { "Content-Type": "application/json" } })



